import { render, staticRenderFns } from "./CustomerServiceFlags.vue?vue&type=template&id=6fada403&scoped=true&"
import script from "./CustomerServiceFlags.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fada403",
  null
  
)

export default component.exports